import type { AxiosInstance } from 'axios';
import type { ServiceResult, ServiceResultT } from '../types/common';
import type { NotificationViewModel } from '../types/notification';
import { apiClient } from '../client/client';

/**
 * Service for user notification endpoints.
 * Separate from NotificationTypeService which is the admin CRUD for notification templates.
 */
export class NotificationService {
  private static readonly BASE = '/api/notification';

  constructor(private readonly client: AxiosInstance = apiClient) {}

  async getAll(): Promise<ServiceResultT<NotificationViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<NotificationViewModel[]>>(
      NotificationService.BASE,
    );
    return data;
  }

  async getUnreadCount(): Promise<ServiceResultT<number>> {
    const { data } = await this.client.get<ServiceResultT<number>>(
      `${NotificationService.BASE}/unread-count`,
    );
    return data;
  }

  async markAsRead(id: string): Promise<ServiceResult> {
    const { data } = await this.client.put<ServiceResult>(
      `${NotificationService.BASE}/${id}/read`,
    );
    return data;
  }

  async markAllAsRead(): Promise<ServiceResult> {
    const { data } = await this.client.put<ServiceResult>(
      `${NotificationService.BASE}/read-all`,
    );
    return data;
  }
}

export const notificationService = new NotificationService();
